import { TableSearch } from '@/shared/data-table/components/table-search'

import {
	CASE_SEARCH_DEBOUNCE_MS,
	CASE_SEARCH_MIN_LENGTH,
} from '../../lib/case-list-params'

type CaseSearchProps = {
	/** The PostHog event, `<prefix>_search`. */
	analyticsEvent: string
	placeholder: string
}

/**
 * The search box of both Case lists. It writes `q` to the URL, and the list
 * sends it to the API as `search` — so it waits for typing to stop and needs
 * {@link CASE_SEARCH_MIN_LENGTH} characters, each change being a request.
 * Enter searches at once. Shared by the filter bar and its skeleton, so the
 * two cannot search differently.
 */
export const CaseSearch = ({
	analyticsEvent,
	placeholder,
}: CaseSearchProps) => (
	<TableSearch
		placeholder={placeholder}
		analyticsEvent={analyticsEvent}
		debounceMs={CASE_SEARCH_DEBOUNCE_MS}
		minLength={CASE_SEARCH_MIN_LENGTH}
	/>
)
